import { TAppState } from '../../types';
import { selectIsSubscription } from '../buyPackageModal';

export const selectSuccessScreenTitle = (state: TAppState): string => {
  const isSubscription = selectIsSubscription(state);

  return isSubscription ? 'Подписка оплачена' : 'Пакет оплачен';
};
